import React from 'react'
import gql from 'graphql-tag'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'

interface Props {
  product: {
    state: string
  }
}

const Drone360Product = ({product}: Props) => {
  if (product.state === 'delivered') {
    return (
      <DeliveredUrl product={product} />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

Drone360Product.fragment = gql`
  fragment Drone360Product on Drone360Product {
    assets {
      edges {
        node {
          id
          state
          ...on UrlAsset {url}
        }
      }
    }
  }
`

export default Drone360Product
